import * as React from "react";
import PropTypes from "prop-types";
const SvgNavigationChallengeFastestActivityNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M.407 4.193C.924 3.777 4.654 1 12 1s11.076 2.777 11.593 3.193c.275.221.407.541.407.852V13c0 3.965-3.026 6.685-5.766 8.35-2.792 1.698-5.639 2.521-5.941 2.607a1.08 1.08 0 01-.586 0c-.302-.086-3.149-.909-5.941-2.606C3.026 19.685 0 16.965 0 13V5.046c0-.298.123-.624.407-.853zM2 5.506V8h13l-1.6-1.2 1.2-1.6 4 3a1 1 0 010 1.6l-4 3-1.2-1.6L15 10H2v3c0 .343.032.676.092 1H10l-1.6-1.2 1.2-1.6 4 3a1 1 0 010 1.6l-4 3-1.2-1.6L10 16H2.87c.875 1.453 2.325 2.663 3.935 3.642 2.19 1.331 4.438 2.083 5.195 2.316.757-.233 3.006-.985 5.195-2.316C19.808 18.053 22 15.852 22 13V5.506C20.981 4.82 17.735 3 12 3S3.019 4.82 2 5.506z"
        fill=""
      />
    </svg>
  )
);
SvgNavigationChallengeFastestActivityNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgNavigationChallengeFastestActivityNormalSmall;
